import React, { useEffect, lazy, Suspense } from "react";
import { connect } from "react-redux";
import { setConfiguration } from "./redux/actions";
import { CreatePostMessage } from "./scripts/PostMessage";
import "./App.scss";

import Header from "./components/Screen/Header/Header";
import Information from "./components/Screen/Information/Information";
import Buttons from "./components/Screen/Buttons/Buttons";
import Style from "./components/Style";

import Scrollbars from "react-custom-scrollbars-2";

// Lazy loaded components
const Partners = lazy(() => import("./components/Screen/Partners/Partners"));
const VendorSettings = lazy(() =>
  import("./components/Screen/Settings/VendorSettings/VendorSettings")
);
const FilterSettings = lazy(() =>
  import("./components/Screen/Settings/FilterSettings/FilterSettings")
);

const App = (props) => {
  const { setConfiguration } = props;

  useEffect(() => {
    // setConfiguration({});
    CreatePostMessage();
  }, [setConfiguration]);

  const renderScreen = () => {
    switch (props.currentScreen) {
      case 4:
        return <Partners />;
      case 3:
        return <VendorSettings />;
      case 2:
        return <FilterSettings />;
      default:
        return <Information />;
    }
  };

  return (
    <div id="consentui" className={`screen_${props.currentScreen}`}>
      <Header />
      <div id="content">
        <Scrollbars className={"content-scrollbar"}>
          <Suspense fallback={<div></div>}>{renderScreen()}</Suspense>
        </Scrollbars>
      </div>
      <Buttons />
      <Style />
    </div>
  );
};

const mapStateToProps = (state) => {
  return { ...state };
};

export default connect(mapStateToProps, { setConfiguration })(App);
